import { render, staticRenderFns } from "./EmployeeDetailsCardWagesDialog.vue?vue&type=template&id=212f73d0&scoped=true&"
import script from "./EmployeeDetailsCardWagesDialog.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsCardWagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetailsCardWagesDialog.vue?vue&type=style&index=0&id=212f73d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f73d0",
  null
  
)

export default component.exports